// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BVoBU","name":"Header_name__2YggK","birthday":"Header_birthday__20vKV","skeleton":"Header_skeleton__NfvsL"};